import { useContext } from "react";

import ProjectContext from "../context/ProjectContext";

export default function useRequireCurrentProject() {
    const { data } = useContext(ProjectContext);
    if (!data) throw Error("Project required");
    return data;
}
